var render = function render(){var _vm=this,_c=_vm._self._c;return _c('XTextField',{attrs:{"label":_vm.label,"value":_vm.dataValue,"rules":_vm.computedRules,"validate-immediately":"","tooltip":"Value between 0 and 65535."},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }